if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (!this.form) {
          console.warn('product-form: no se encontró un formulario.');
          return;
        }

        this.variantIdInput = this.form.querySelector('[name="id"]');
        if (this.variantIdInput) this.variantIdInput.disabled = false;

      // ✅ DESPUÉS (correcto)
this.cart =
  document.querySelector('cart-drawer') ||
  document.querySelector('cart-notification');


        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton
          ? this.submitButton.querySelector('span')
          : null;

        if (this.submitButton && document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';

        this.form.addEventListener(
          'submit',
          this.onSubmitHandler.bind(this)
        );
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (!this.form || !this.submitButton) return;

        if (
          this.submitButton.getAttribute('aria-disabled') === 'true' ||
          this.submitButton.disabled
        ) {
          return;
        }

        this.handleErrorMessage();

        const loadingSpinner = this.querySelector('.loading__spinner');

        this.submitButton.setAttribute('aria-disabled', 'true');
        this.submitButton.classList.add('loading');

        if (loadingSpinner) {
          loadingSpinner.classList.remove('hidden');
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        if (this.cart) {
          const sections = this.cart.getSectionsToRender
            ? this.cart.getSectionsToRender().map((section) => section.id)
            : [];

          if (sections.length) {
            formData.append('sections', sections);
          }

          formData.append('sections_url', window.location.pathname);

          if (this.cart.setActiveElement) {
            this.cart.setActiveElement(document.activeElement);
          }
        }

        config.body = formData;

        const variantId = formData.get('id');
        const quantity = parseInt(formData.get('quantity'), 10) || 1;

        if (!variantId) {
          const message = 'No se encontró una variante válida.';
          this.handleErrorMessage(message);
          this.dispatchCartErrorEvent(message, 'MISSING_VARIANT');

          this.submitButton.classList.remove('loading');
          this.submitButton.removeAttribute('aria-disabled');

          if (loadingSpinner) {
            loadingSpinner.classList.add('hidden');
          }

          return;
        }

        const linesUpdateDeferred =
          this.createCartLinesUpdateEvent(variantId, quantity);

        fetch(`${routes.cart_add_url}`, config)
          .then(async (httpResponse) => {
            const response = await httpResponse.json();

            if (!httpResponse.ok) {
              response.__httpError = true;
            }

            return response;
          })
          .then((response) => {
            const hasCartError =
              response.__httpError === true ||
              Boolean(response.errors) ||
              Boolean(response.description && response.status >= 400);

            if (hasCartError) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: variantId,
                errors: response.errors || response.description,
                message: response.message,
              });

              this.handleErrorMessage(response.description);
              this.showToast(
                'error',
                response.description || response.message || 'No se pudo agregar el producto.'
              );

              this.dispatchCartErrorEvent(
                response.description || response.message,
                'INVALID'
              );

              linesUpdateDeferred?.reject(
                new Error(response.description || response.message)
              );

              const soldOutMessage =
                this.submitButton.querySelector('.sold-out-message');

              if (soldOutMessage) {
                this.submitButton.setAttribute('aria-disabled', 'true');

                if (this.submitButtonText) {
                  this.submitButtonText.classList.add('hidden');
                }

                soldOutMessage.classList.remove('hidden');
              }

              this.error = true;
              return;
            }

            this.error = false;

            this.showToast(
              'success',
              'Tu producto se agregó exitosamente.'
            );

            document.dispatchEvent(
              new CustomEvent('savia:product-added', {
                detail: {
                  variantId: variantId,
                  quantity: quantity,
                  cartData: response,
                },
              })
            );

            this.resolveCartLinesUpdate(linesUpdateDeferred);

            if (
              typeof publish === 'function' &&
              typeof PUB_SUB_EVENTS !== 'undefined' &&
              PUB_SUB_EVENTS.cartUpdate
            ) {
              try {
                const published = publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'product-form',
                  productVariantId: variantId,
                  cartData: response,
                });

                if (published && typeof published.catch === 'function') {
                  published.catch((publishError) => {
                    console.warn('product-form cartUpdate:', publishError);
                  });
                }
              } catch (publishError) {
                console.warn('product-form cartUpdate:', publishError);
              }
            }

            const quickAddModal = this.closest('quick-add-modal');

            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    try {
                      if (this.cart && typeof this.cart.renderContents === 'function') {
                        this.cart.renderContents(response);
                      }
                    } catch (renderError) {
                      console.warn('product-form renderContents:', renderError);
                    }
                  }, 0);
                },
                { once: true }
              );

              if (typeof quickAddModal.hide === 'function') {
                quickAddModal.hide(true);
              }
            } else {
              try {
                if (this.cart && typeof this.cart.renderContents === 'function') {
                  this.cart.renderContents(response);
                }
              } catch (renderError) {
                console.warn('product-form renderContents:', renderError);
              }
            }

            return response;
          })
          .catch((error) => {
            console.error(error);
            this.showToast(
              'error',
              'No se pudo agregar el producto. Inténtalo nuevamente.'
            );

            this.dispatchCartErrorEvent(
              error.message || 'Network error',
              'SERVICE_UNAVAILABLE'
            );

            linesUpdateDeferred?.reject(error);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');

            if (
              this.cart &&
              this.cart.classList.contains('is-empty')
            ) {
              this.cart.classList.remove('is-empty');
            }

            if (!this.error) {
              this.submitButton.removeAttribute('aria-disabled');
            }

            if (loadingSpinner) {
              loadingSpinner.classList.add('hidden');
            }

            if (
              typeof CartPerformance !== 'undefined' &&
              typeof CartPerformance.measureFromEvent === 'function'
            ) {
              try {
                CartPerformance.measureFromEvent(
                  'add:user-action',
                  evt
                );
              } catch (performanceError) {
                console.warn('product-form performance:', performanceError);
              }
            }
          });
      }

      showToast(type, message) {
        let toast = document.querySelector('.savia-product-toast');

        if (!toast) {
          toast = document.createElement('div');
          toast.className = 'savia-product-toast';
          toast.setAttribute('role', 'status');
          toast.setAttribute('aria-live', 'polite');

          toast.innerHTML = `
            <div class="savia-product-toast__icon" aria-hidden="true"></div>
            <div class="savia-product-toast__message"></div>
            <button
              type="button"
              class="savia-product-toast__close"
              aria-label="Cerrar mensaje"
            >
              ×
            </button>
          `;

          document.body.appendChild(toast);

          toast
            .querySelector('.savia-product-toast__close')
            .addEventListener('click', () => {
              toast.classList.remove('is-visible');
            });

          if (!document.getElementById('savia-product-toast-styles')) {
            const style = document.createElement('style');
            style.id = 'savia-product-toast-styles';
            style.textContent = `
              .savia-product-toast {
                position: fixed;
                left: 50%;
                bottom: max(22px, env(safe-area-inset-bottom));
                z-index: 2147483647;
                display: flex;
                align-items: center;
                gap: 12px;
                width: min(calc(100% - 24px), 460px);
                padding: 14px 48px 14px 16px;
                border-radius: 14px;
                background: #ffffff;
                color: #222222;
                box-shadow: 0 14px 40px rgba(0, 0, 0, 0.18);
                border: 1px solid rgba(0, 0, 0, 0.08);
                opacity: 0;
                visibility: hidden;
                transform: translate(-50%, 18px);
                transition:
                  opacity .25s ease,
                  transform .25s ease,
                  visibility .25s ease;
              }

              .savia-product-toast.is-visible {
                display: flex !important;
                opacity: 1 !important;
                visibility: visible !important;
                transform: translate(-50%, 0) !important;
              }

              .savia-product-toast.is-success {
                border-color: rgba(46, 125, 50, .28);
                background: #f4fbf5;
              }

              .savia-product-toast.is-error {
                border-color: rgba(190, 35, 35, .28);
                background: #fff5f5;
              }

              .savia-product-toast__icon {
                flex: 0 0 30px;
                width: 30px;
                height: 30px;
                border-radius: 999px;
                display: grid;
                place-items: center;
                font-weight: 800;
                color: #ffffff;
              }

              .savia-product-toast.is-success .savia-product-toast__icon {
                background: #2e7d32;
              }

              .savia-product-toast.is-error .savia-product-toast__icon {
                background: #b42318;
              }

              .savia-product-toast__message {
                font-size: 15px;
                font-weight: 700;
                line-height: 1.35;
              }

              .savia-product-toast__close {
                position: absolute;
                top: 50%;
                right: 14px;
                width: 32px;
                height: 32px;
                transform: translateY(-50%);
                border: 0;
                background: transparent;
                color: currentColor;
                font-size: 24px;
                line-height: 1;
                cursor: pointer;
              }

              @media screen and (max-width: 749px) {
                .savia-product-toast {
                  bottom: max(14px, env(safe-area-inset-bottom));
                  width: calc(100% - 20px);
                  padding: 13px 44px 13px 14px;
                  border-radius: 12px;
                }

                .savia-product-toast__message {
                  font-size: 14px;
                }
              }

              @media (prefers-reduced-motion: reduce) {
                .savia-product-toast {
                  transition: none;
                }
              }
            `;
            document.head.appendChild(style);
          }
        }

        const icon = toast.querySelector('.savia-product-toast__icon');
        const messageElement = toast.querySelector('.savia-product-toast__message');

        toast.classList.remove('is-success', 'is-error');
        toast.classList.add(type === 'error' ? 'is-error' : 'is-success');

        icon.textContent = type === 'error' ? '!' : '✓';
        messageElement.textContent = message;

        toast.classList.remove('is-visible');
        void toast.offsetWidth;
        toast.classList.add('is-visible');

        clearTimeout(window.__saviaProductToastTimer);
        window.__saviaProductToastTimer = setTimeout(() => {
          toast.classList.remove('is-visible');
        }, 3500);
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('.product-form__error-message-wrapper');

        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );

        this.errorMessageWrapper.toggleAttribute(
          'hidden',
          !errorMessage
        );

        if (errorMessage && this.errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (!this.submitButton) return;

        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');

          if (text && this.submitButtonText) {
            this.submitButtonText.textContent = text;
          }
        } else {
          this.submitButton.removeAttribute('disabled');

          if (this.submitButtonText) {
            this.submitButtonText.textContent =
              window.variantStrings.addToCart;
          }
        }
      }

      createCartLinesUpdateEvent(variantId, quantity) {
        const { CartLinesUpdateEvent } =
          window.StandardEvents || {};

        if (!CartLinesUpdateEvent) return null;

        const deferred = CartLinesUpdateEvent.createPromise();

        this.dispatchEvent(
          new CartLinesUpdateEvent({
            action: 'add',
            context: 'product',
            lines: [{ merchandiseId: variantId, quantity }],
            promise: deferred.promise,
          })
        );

        return deferred;
      }

      resolveCartLinesUpdate(deferred) {
        if (!deferred) return;

        const { CartLinesUpdateEvent } =
          window.StandardEvents || {};

        if (!CartLinesUpdateEvent) return;

        const pendingCartDataPromise =
          typeof CartItems !== 'undefined'
            ? CartItems.fetchCartData()
            : fetch(`${routes.cart_url}.json`).then((response) =>
                response.json()
              );

        pendingCartDataPromise
          .then((cart) => {
            if (!cart?.currency) {
              return deferred.reject(
                new Error('Missing currency in cart response')
              );
            }

            deferred.resolve({
              cart:
                CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
            });
          })
          .catch((error) => deferred.reject(error));
      }

      dispatchCartErrorEvent(message, code) {
        const { CartErrorEvent } =
          window.StandardEvents || {};

        if (!CartErrorEvent) return;

        this.dispatchEvent(
          new CartErrorEvent({
            error: message,
            code,
          })
        );
      }
    }
  );
}